export enum CompassEvent {
    TABLE_COLUMNS_RESIZED = 'compass-table:columnsResized',
}

export interface CompassEventMap {
    [CompassEvent.TABLE_COLUMNS_RESIZED]: void;
}
